import { KeyValue } from "@/common/components/key-value";
import { H3 } from "@/common/elements";

interface IRegulatoryNote {
  reason: string;
  regulatoryNote?: string;
}

const RegulatoryNote = ({ reason, regulatoryNote }: IRegulatoryNote) => {
  return (
    <div className="regulatoryWrapper">
      <H3>Recall Reason & Regulatory Note</H3>
      <div className="regulatoryReason">
        {<KeyValue title="Recall Reason:" value={reason} />}
        {regulatoryNote && (
          <KeyValue title="Regulatory Note:" value={regulatoryNote} />
        )}
      </div>
    </div>
  );
};

export default RegulatoryNote;
